import { Enum  } from "./Enum";

export const OrderTypeEnum: Enum[] = [
  { id: 'basic', name: 'Basic' }
];